<div class="rl">
  @if (removedPhoneNumbers.length) {
  <p class="rl__intro">
    You removed these numbers from the list. They will not be added.
  </p>
  <ul class="rl__list">
    @for (removed of removedPhoneNumbers; track $index) {
    <li class="phoneNumber rl__item">
      <span class="number">{{ removed.phoneNumber || '(empty)' }}</span>
    </li>
    }
  </ul>
  } @else {
  <div class="noRemoved rl__empty">
    <span class="bk-sym" aria-hidden="true">remove_circle</span>
    <p class="rl__empty-title">Nothing removed</p>
    <p class="rl__empty-body">
      To leave a number out, go back to Check numbers and use the cross next to it.
    </p>
  </div>
  }
</div>
